import { render, staticRenderFns } from "./RgObjectListTab.vue?vue&type=template&id=04112980&scoped=true&"
import script from "./RgObjectListTab.vue?vue&type=script&lang=js&"
export * from "./RgObjectListTab.vue?vue&type=script&lang=js&"
import style0 from "./RgObjectListTab.vue?vue&type=style&index=0&id=04112980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04112980",
  null
  
)

export default component.exports